'use client'

import { Tag } from '@/components/ui/tag'
import { cn } from '@/lib/utils'
import { FilterTag } from '../../../utils/filter-tag-utils'

interface FilterBarTagsProps {
  tags: FilterTag[]
  onRemoveTag: (tag: FilterTag) => void
  className?: string
}

export const FilterBarTags = ({
  tags,
  onRemoveTag,
  className,
}: FilterBarTagsProps) => {
  if (!tags.length) return null

  // check nếu có parentKey là "gender_type" thì render tag theo t('gender_type')
  const tagsWithGenderType = tags.map((tag) => {
    return tag
  })

  return (
    <div
      className={cn(
        'flex flex-wrap items-center gap-3 border-b border-b-neutral-200 pb-4 lg:border-b-0 lg:pb-0',
        className
      )}
    >
      {tagsWithGenderType.map((tag) =>
        tag ? (
          <Tag
            title={tag.title}
            size='small'
            key={tag.key}
            closable
            onClose={() => onRemoveTag(tag)}
            className='max-lg:rounded-full max-lg:border-none max-lg:bg-neutral-100 max-lg:text-xs max-lg:text-neutral-500 lg:rounded'
          />
        ) : null
      )}
    </div>
  )
}
